// Function for dynamic title
export const TabChange = (newTitle) => {
    return (document.title = newTitle)
}